import React, { useState } from 'react';

const DashboardReviewCard = ({ ratingLinks, t, navigate, reviewEmail }) => {
  const [selectedRating, setSelectedRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const displayRating = hoveredRating || selectedRating;

  const handleRating = (rating) => {
    setSelectedRating(rating);
    const destination = ratingLinks?.[rating];
    if (!destination) return;

    if (destination.startsWith('/')) {
      // Router state, not a query param — keeps the address out of the URL and
      // therefore out of the PageView reported to Meta and Contentsquare.
      navigate?.(destination, { state: { email: reviewEmail } });
    } else {
      window.open(destination, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section className="t-rounded-[14px] t-border t-border-g200 t-bg-white t-p-6">
      <p className="t-m-0 t-text-lg t-font-extrabold t-text-navy">{t('Dashboard_Review_Title')}</p>
      <p className="t-m-0 t-mt-1 t-text-sm t-text-teal-muted">
        {t('Dashboard_Review_Body')}
      </p>
      <div className="t-mt-5 t-flex t-gap-1" onMouseLeave={() => setHoveredRating(0)}>
        {[1, 2, 3, 4, 5].map((rating) => (
          <button
            type="button"
            key={`dashboard-rating-${rating}`}
            className={`t-transform t-border-0 t-bg-transparent t-p-0 t-text-[28px] t-leading-none t-transition-all t-duration-150 t-ease-out hover:t-scale-110 ${
              displayRating >= rating ? 't-text-butter' : 't-text-g200'
            }`}
            aria-label={t('Dashboard_Review_StarLabel', { rating })}
            onMouseEnter={() => setHoveredRating(rating)}
            onClick={() => handleRating(rating)}
          >
            ★
          </button>
        ))}
      </div>
      <p className="t-m-0 t-mt-5 t-text-xs t-leading-relaxed t-text-teal-muted">
        {t('Dashboard_Review_Stat')}
        <br />
        {t('Dashboard_Review_Gift')}
      </p>
    </section>
  );
};

export default DashboardReviewCard;
